import { render } from "./tuserAutoSearch.vue?vue&type=template&id=93518e94&scoped=true"
import script from "./tuserAutoSearch.vue?vue&type=script&lang=js"
export * from "./tuserAutoSearch.vue?vue&type=script&lang=js"

import "./tuserAutoSearch.vue?vue&type=style&index=0&id=93518e94&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93518e94"]])

export default __exports__